export default {
      id: "output-usage",
      viewBox: "0 0 38 35",
      url: __webpack_public_path__ + "img/icons.svg#output",
      toString: function () {
        return this.url;
      }
    }